import { Formik } from "formik";
import { Form } from "react-bootstrap";
import MyInput from "src/components/common/FormElements/MyInput";
import { monthsInfo } from "./RankHistoryBody";
import { Fragment } from "react";

const RankPageFilter = ({
  selectedMonth,
  onMonth,
  searchInputRef,
  onSearch,
  isSearching,
}) => {
  const renderFormCheck = monthLabel => {
    return (
      <Form.Check
        inline
        label={monthLabel}
        name="group1"
        type="radio"
        id={monthLabel}
        onChange={() => onMonth(monthLabel)}
        checked={selectedMonth === monthLabel}
      />
    );
  };

  return (
    <div className="filter-wrapper">
      <div className="col-md-12 d-flex">
        <div className="d-flex align-items-center mb-2 col-md-4">
          <span>処理区分：</span>
          <div className="border radio-button-container">
            <Form>
              {Object.keys(monthsInfo).map(monthLabel => {
                return (
                  <Fragment key={monthLabel}>
                    {renderFormCheck(monthLabel)}
                  </Fragment>
                );
              })}
            </Form>
          </div>
        </div>
        <Formik
          initialValues={{ member_code: "" }}
          enableReinitialize={true}
          onSubmit={formData => {
            onSearch(formData.member_code);
          }}
        >
          {formik => {
            const disabled = isSearching;

            return (
              <div className="d-flex align-items-center mb-2 col-md-4 member-search">
                <Form id="search-form" onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-3 text-md-end pt-1">会具番号：</div>
                    <div className="col-5">
                      <MyInput
                        label=""
                        name="member_code"
                        type="text"
                        placeholder=""
                        disabled={disabled}
                        inputRef={searchInputRef}
                        autoComplete="off"
                        selectTextOnFocus={true}
                        onKeyDown={e => {
                          if (e.code === "Tab" && !e.shiftKey) {
                            e.preventDefault();
                            formik.submitForm();
                          }
                        }}
                      />
                    </div>
                    <div className="col-3">
                      <button
                        disabled={disabled}
                        className="btn btn-primary w-100"
                        type="submit"
                        tabIndex={-1}
                      >
                        検索
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default RankPageFilter;
